import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "@/lib/LanguageContext";
import { LAPORAN_CATEGORIES } from "@/lib/laporan";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { ArrowRight, ChevronRight } from "lucide-react";

const LaporanIndex = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex flex-col bg-slate-50" data-testid="laporan-index">
      <Header />
      <main className="flex-1 pt-28 md:pt-32 pb-16">
        <div className="container-x">
          <div className="mb-4 flex items-center gap-2 text-xs text-slate-500">
            <Link to="/" className="hover:text-blue-800">
              {t.nav.home}
            </Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-blue-800 font-medium">{t.nav.laporan}</span>
          </div>

          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold mb-2">
              {t.laporan.overline}
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-3">
              {t.laporan.title}
            </h1>
            <p className="text-slate-600 leading-relaxed">
              {t.laporan.subtitle}
            </p>
          </div>

          <div className="mt-12 grid gap-5 sm:grid-cols-2">
            {LAPORAN_CATEGORIES.map((c, idx) => {
              const Icon = c.icon;
              return (
                <motion.div
                  key={c.slug}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <Link
                    to={`/laporan/${c.slug}`}
                    data-testid={`laporan-card-${c.slug}`}
                    className="group block bg-white rounded-3xl border border-slate-100 hover:border-blue-100 shadow-sm hover:shadow-xl transition-all overflow-hidden"
                  >
                    <div className={`h-1.5 bg-gradient-to-r ${c.accent}`} />
                    <div className="p-6">
                      <div className={`h-12 w-12 rounded-2xl ${c.tint} flex items-center justify-center mb-4`}>
                        <Icon className="h-6 w-6" />
                      </div>
                      <h3 className="font-heading text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-800 transition">
                        {t.laporan[c.key_title]}
                      </h3>
                      <p className="text-sm text-slate-500 leading-relaxed mb-4">
                        {t.laporan[c.key_desc]}
                      </p>
                      <div className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-800">
                        {t.laporan.view_report}
                        <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                      </div>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default LaporanIndex;
